
/// / The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'

// Основные
import VueResource from 'vue-resource'
import VueHead from 'vue-head'

// Дополнительные
import VueGtm from 'vue-gtm'
import moment from 'vue-moment'
import { VueMaskDirective } from 'v-mask'
import ClickOutside from 'vue-click-outside'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import Vuelidate from 'vuelidate'
import { sync } from 'vuex-router-sync'
import PortalVue from 'portal-vue'
// не работает без doctype на мобилах
// import VueWaypoint from 'vue-waypoint'
// Локальные
import MGSmoothScroll from './plugins/scroll'
import SvgInline from './components/SvgInlineImage'
import vSelect from 'vue-select'
import Rub from './components/Rub'

// modules
import router from './router'
import store from './store'
import './mixin'
import rootMixin from './mixin/root'
import gtmMixin from './mixin/gtm'

// Ошибки
// import Raven from 'raven-js'
// import RavenVue from 'raven-js/plugins/vue'

// plugins
// import FacebookApiWrapper from './plugins/facebook-api-wrapper'
// import VK from './plugins/vkontakte-api-wrapper/VK'
// import VkontakteApiWrapper from './plugins/vkontakte-api-wrapper'

import './assets/styles/main.scss'
import Cookies from 'js-cookie'

// SVG shim
Vue.use(VueGtm, {
  debug: Cookies.get('gtm_debug') ? Cookies.get('gtm_debug') : false // Whether or not display console logs debugs (optional)
})

// getting API_ROOT
// const configDev = require('../config/dev.env.js')
// const configProd = require('../config/prod.env.js')

// по усполчанию смотрим в куки и загружаем конфиг для стэйджа
// let API_ROOT = Cookies.get('API_ROOT') ? Cookies.get('API_ROOT') : configDev.API_ROOT
// // let FRONT_URL = Cookies.get('FRONT_URL') ? Cookies.get('FRONT_URL') : configDev.FRONT_URL
// if (process.env.NODE_ENV === 'production') {
//   // если билд для прода то смотрим в куки или в конфиг для прода
//   API_ROOT = Cookies.get('API_ROOT') ? Cookies.get('API_ROOT') : configProd.API_ROOT
//   // FRONT_URL = Cookies.get('FRONT_URL') ? Cookies.get('FRONT_URL') : configProd.FRONT_URL
// }

require('moment/locale/ru')
/*
* plugins
* */

Vue.config.productionTip = false
Vue.use(VueResource)
Vue.use(VueAwesomeSwiper)
Vue.use(VueHead)
Vue.use(MGSmoothScroll)
Vue.use(moment)
Vue.use(Vuelidate)
Vue.use(PortalVue)

// Vue.use(VK)
// Vue.use(VkontakteApiWrapper, { appId: 6342461 })

Vue.component('svg-inline', SvgInline)
Vue.component('rub', Rub)
Vue.directive('click-outside', ClickOutside)
Vue.directive('mask', VueMaskDirective)
Vue.component('v-select', vSelect)
// Waypoint plugin
// не работает без doctype на мобилах
// Vue.use(VueWaypoint)

// if (process.env.NODE_ENV === 'production') {
//   Raven
//     .config('https://eeac5a2970a84d53bbc382b36afca9ff@sentry.io/288025', {
//       release: '1.1.1',
//       autoBreadcrumbs: {
//         'xhr': false,      // XMLHttpRequest
//         'console': true,  // console logging
//         'dom': true,       // DOM interactions, i.e. clicks/typing
//         'location': true, // url changes, including pushState/popState
//         'sentry': true     // sentry events
//       }
//     })
//     .addPlugin(RavenVue, Vue)
//     .install()
// }

router.beforeEach((to, from, next) => {
  if (to.path !== from.path) {
    // store.dispatch('gtm/changeUrl')
  }
  next()
})

Vue.http.options.crossOrigin = true
// Vue.http.interceptors.push((request, next) => {
//   const token = Cookies.get('client_token')
//
//   if (token && request.url.includes(API_ROOT)) {
//     request.headers.set('X-Client-Token', token)
//   }
//   if (request.url.startsWith(API_ROOT)) {
//     const antiCaptchaToken = router.currentRoute.query.no_captcha || Cookies.get('no_captcha')
//     if (antiCaptchaToken) {
//       request.headers.set('X-Anticaptcha-Token', antiCaptchaToken)
//     }
//   }
//   next(response => {
//     if (response.status === 401) {
//       Cookies.remove('client_id_h')
//       store.dispatch('client/logout')
//     }
//   })
// })

// Create a global Event Bus
// export let eventBus = new Vue()
export const EventBus = new Vue()
sync(store, router)

// Add to Vue properties by exposing a getter for $bus
Object.defineProperties(Vue.prototype, {
  $bus: {
    get () {
      return EventBus
    }
  }
})

/* eslint-disable no-new */
const root = new Vue({
  el: '#app',
  router,
  store,
  mixins: [rootMixin, gtmMixin],
  template: '<App/>',
  components: { App }
})

if (process.env.NODE_ENV === 'development') {
  window.app = root
}



// WEBPACK FOOTER //
// ./src/main.js